// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TextArea } from 'informed';

import {
  addSignificantHistory,
  deleteSignificantHistory,
  updateSignificantHistory,
} from '../../../actions/informationHistoryActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  significantHistory: Object[],
  activePatientId: string,
  addSignificantHistory: Function,
  deleteSignificantHistory: Function,
  updateSignificantHistory: Function,
}

class SignificantHistoryComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteSignificantHistory(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateSignificantHistory(this.props.activePatientId, {
      significantHistoryId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addSignificantHistory(this.props.activePatientId, formData.values);
  }

  render() {
    const columns = [
      {
        Header: 'Event',
        id: 'event',
        editCell: item => <Typeahead field='event' initialValue={item.event} endpoint='sigHxEvent' />,
      },
      {
        Header: 'Details',
        id: 'details',
        editCell: item => <TextArea field='details' initialValue={item.details} />,
      },
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
      },
    ];

    return (
      <Table
        columns={columns}
        data={this.props.significantHistory}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  significantHistory: state.patient.data.significantHistory,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addSignificantHistory:
    (patientId, significantHistory) => dispatch(addSignificantHistory(patientId, significantHistory)),
  deleteSignificantHistory:
    (patientId, significantHistoryId) => dispatch(deleteSignificantHistory(patientId, significantHistoryId)),
  updateSignificantHistory:
    (patientId, significantHistory) => dispatch(updateSignificantHistory(patientId, significantHistory)),
});

const SignificantHistory = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignificantHistoryComponent);

export default SignificantHistory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/SignificantHistory.jsx